export const config = {
    url: 'https://editor.56show.com/api/v1/cmd/receive',
    headers: { 'Content-Type': 'application/json' },
};
if (process.env.NODE_ENV === 'development') {
     config.url = 'http://localhost/api/v1/cmd/receive';
}

export interface Result<T> {
    code: number;
    error: string;
    message: string;
    meta: { count: number } | null;
    status: 'success' | 'fail' | 'error';
    data: T;
}

export const get = async <T>(
    cmd: string,
    param: { [key: string]: any } = {},
): Promise<Result<T>> => {
    try {
        const response = await fetch(
            `${config.url}?cmd=${cmd}&${new URLSearchParams(param).toString()}`,
            {
                method: 'GET',
                headers: config.headers,
            },
        );
        const data: Result<T> = await response.json();
        if (data.code === 200) {
            return Promise.resolve(data);
        } else {
            return Promise.reject(data.message);
        }
    } catch (e) {
        return Promise.reject(e);
    }
};

export const post = async <T>(
    cmd: string,
    param: { [key: string]: any } = {},
): Promise<Result<T>> => {
    try {
        const response = await fetch(config.url, {
            method: 'POST',
            body: JSON.stringify({ cmd, param }),
            headers: config.headers,
        });
        const data: Result<T> = await response.json();
        if (data.code === 200) {
            return Promise.resolve(data);
        } else {
            return Promise.reject(data.message);
        }
    } catch (e) {
        return Promise.reject(e);
    }
};

export default { get, post };
